import { lazy } from 'react';
import PATH from 'routes/paths';
import { Route } from 'routes/types';

const ConnectedFavoritesBusinessExperiencesPage = lazy(
  () =>
    import(
      '../../components/smart/pages/businessPages/favorites/ConnectedFavoritesBusinessExperiencesPage'
    )
);

const ConnectedFavoriteCompaniesPage = lazy(
  () =>
    import(
      '../../components/smart/pages/businessPages/favorites/ConnectedFavoriteCompaniesPage'
    )
);

const BUSINESS_FAVORITE_EXPERIENCES: Route = {
  component: ConnectedFavoritesBusinessExperiencesPage,
  path: PATH.BUSINESS.FAVORITE_EXPERIENCES,
  isProtected: true,
  hasMenuBar: true,
};

const BUSINESS_FAVORITE_COMPANIES: Route = {
  component: ConnectedFavoriteCompaniesPage,
  path: PATH.BUSINESS.FAVORITE_COMPANIES,
  isProtected: true,
  hasMenuBar: true,
};

export default [BUSINESS_FAVORITE_EXPERIENCES, BUSINESS_FAVORITE_COMPANIES];
